export enum ModalKey {
	AppVersionInfo = 'AppVersionInfo',
	AzeDialogView = 'AzeDialogView',
	EFile = 'EFile',
	EventDialogView = 'EventDialogView',
	Freigabe = 'Freigabe',
	MaintenanceDuplicate = 'MaintenanceDuplicate',
	MultiEditAutoApiAction = 'MultiEdit.AutoApiAction',
	NotiDrawer = 'NotiDrawer',
	PersonInfo = 'PersonInfo',
	Persst = "Persst",
	PlanTempl = "PlanTempl",
	PlanPersist = "PlanPersist",
	MaintenanceTabs = 'MaintenanceTabs',
	MultiKostInit = 'MultiKostInit',
	SessionInfo = 'SessionInfo',
	TaskDrawer = 'TaskDrawer',
	TaskZu = 'TaskZu',
	UserConfig = 'UserConfig',
	VerrLauf = 'VerrLauf',
}